// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V9dhf","newExpiryDate":"styles_newExpiryDate__Ciywl","footer":"styles_footer__S89bs"};